import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { v4 as uuidv4 } from 'uuid';

import agregarCategoria from '../img/tabla/agregarCategoria.svg';
import agregar from '../img/tabla/agregar.svg';
import quitar from '../img/tabla/quitar.svg';
import duplicar from '../img/tabla/duplicar.svg';

import { iniAddItem, iniAddTitle, iniDuplicateItem, iniRemoveItem } from '../../../redux/actions/pptosGastos';

export const ItemsActions = ({
    item,
    openSubTitles,
    hanldeChangeOpenSubtitle = false,
    showAddTitle_ = true,
    showAddItem_ = true,
    showRemoveItem_ = true,
    showDuplicateItem_ = true,
    sorting = 0
}) => {

    const dispatch = useDispatch();
    const { detail } = useSelector(state => state.ppto);
    const { items } = useSelector(state => state.ppto.detail);

    const addTitle = () => {
        dispatch(iniAddTitle(items));
    }

    const addItem = () => {
        const idTitle = (item.tipo === 'title' ? item.id : item.id_titulo)
        const categoryId = item.id_categoria

        dispatch(iniAddItem(idTitle, items, sorting, null, categoryId))
        if (!openSubTitles && hanldeChangeOpenSubtitle) {
            hanldeChangeOpenSubtitle()
        }
    }

    const duplicateItem = () => {
        dispatch(iniDuplicateItem(items, item));
    }

    const removeItem = () => {
        dispatch(iniRemoveItem(items, item, detail));
    }

    return (
        <div className='d-flex align-items-center justify-content-center'>
            {showAddTitle_ && (
                <button className='ButtonsAction' style={{ marginRight: '3px' }}>
                    <img
                        className='tabla-icons-actions'
                        src={agregarCategoria}
                        alt='agregar título'
                        title='Agregar nuevo título'
                        onClick={addTitle}
                    />
                </button>
            )}
            {showAddItem_ && (
                <button className='ButtonsAction' style={{ marginRight: '3px' }}>
                    <img
                        className='tabla-icons-actions'
                        src={agregar}
                        alt='agregar ítem'
                        title='Agregar nuevo ítem'
                        onClick={addItem}
                    />
                </button>
            )}
            {showRemoveItem_ && (
                <button className='ButtonsAction' style={{ marginRight: '3px' }}>
                    <img
                        className='tabla-icons-actions'
                        src={quitar}
                        alt='quitar ítem'
                        title='Quitar ítem'
                        onClick={removeItem}
                    />
                </button>
            )}
            {showDuplicateItem_ && (
                <button className='ButtonsAction' style={{ marginRight: '3px' }}>
                    <img
                        className='tabla-icons-actions'
                        src={duplicar}
                        alt='duplicar ítem'
                        title='Duplica ítem'
                        onClick={duplicateItem}
                    />
                </button>
            )}
        </div>
    );
};